import * as React from 'react';
import { connect } from 'react-redux';
import { ApplicationState } from '../../../store';
import { SftpImportConfigurationWorkflow } from '../../../store/Models/Api/SftpImportModels';
import { ToxnotComponent, ToxnotComponentProperties } from '../../core/BaseApplicationComponents/ToxnotComponent';
import { FileStructureSection } from '../sections/FileStructureSection';

interface SupplierDefaultHandlingPanelLocalProps {
    config: SftpImportConfigurationWorkflow;
}

type SupplierDefaultHandlingPanelProps = SupplierDefaultHandlingPanelLocalProps & ToxnotComponentProperties;

class SupplierDefaultHandlingPanelComponent extends ToxnotComponent<SupplierDefaultHandlingPanelProps> {
    render() {
        const { config } = this.props;

        return (
            <div className="panel panel-default">
                <div className="panel-heading">
                    <h3 className="panel-title">{this.localizeString("Default Handling")}</h3>
                </div>
                <div className="panel-body" style={{ maxHeight: '400px', overflowY: 'auto' }}>
                    <div className="row">
                        <div className="col-md-12">
                            <div className="start-subcontent-heading">{this.localizeString("File Structure")}</div>
                            <FileStructureSection
                                configData={config}
                                onConfigChange={() => {}} // Read-only mode
                                readOnly={true}
                            />
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export const SupplierDefaultHandlingPanel = connect(
    (state: ApplicationState) => ({ appServices: state.appServices! })
)(SupplierDefaultHandlingPanelComponent);
